import actions from './remindPassFormActions';

const initState = {
    email: '',
    errorMessage: '',
    isInvalidEmail: false,
    isUnknownEmail: false,
    isPassedSuccessful: false,
    isLoading: false,
};

const remindPassFormReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.REMIND_PASS_FORM__CHANGE_EMAIL:
            return {
                ...state,
                email: action.email,
                isInvalidEmail: false,
                isUnknownEmail: false,
            };

        case actions.REMIND_PASS_FORM__VALIDATE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                isInvalidEmail: action.isInvalidEmail,
            };

        case actions.REMIND_PASS_FORM__SUBMIT:
            return {
                ...state,
                isLoading: true,
            };

        case actions.REMIND_PASS_FORM__SHOW_SUCCESSFUL_MESSAGE:
            return {
                ...state,
                isPassedSuccessful: true,
                isLoading: false,
            };

        case actions.REMIND_PASS_FORM__SHOW_ERROR:
            return {
                ...state,
                isUnknownEmail: true,
                errorMessage: action.errorMessage,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default remindPassFormReducer;
